import React, { useState, useRef, forwardRef, useCallback, useMemo, useEffect } from "react";
import { Button, Collapse, Input } from "reactstrap";
import './index.scss';
import { arrayToString, isValEmpty } from "../../../../utils/common";
import { errorCode } from "../../../../utils/constants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import NoRecord2 from "../../../../components/common/NoRecord2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faChevronUp, faChevronDown, faCalculator } from "@fortawesome/free-solid-svg-icons";
import { validationDataAction } from "../../../../context/actions/tempAction";
import { useDispatch, useSelector } from 'react-redux';
import Calculator from '../../../../components/common/Calculator';
import { text } from "@fortawesome/fontawesome-svg-core";
// import InputMask from 'react-input-mask';
import MaskedInput from 'react-text-mask';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
var _ = require('lodash');

const DocumentAccordion = ({ className = '', disabledInputText, valiadationData, setValiadationDetail, _changesValidationText, _selectMoriOption, _validate, _OnVTextChange, invalidFields, setInvalidFields, unableToValidate, xmlTags }) => {
	const [showCalculator, setShowCalculator] = useState(false);
	const [validationKeyId, setValidationKeyId] = useState(null);
	const [outputValue, setOutputValue] = useState(undefined)
	const [dataForCalc, setDataForCalc] = useState(null)

	if (valiadationData?.processedDocument?.results) {
		valiadationData.processedDocument.results.map((data) => {
			if (!data?.sortOrder) {
				data.sortOrder = 0;
			}
			return data

		})
		valiadationData.processedDocument.results = _.orderBy(valiadationData.processedDocument.results, 'sortOrder', 'desc')
	}

	// const years = _.range(1900, new Date().getFullYear() + 1001, 1);
	const years = useMemo(() => {
		const currentYear = new Date().getFullYear();
		return _.range(1900, currentYear + 101, 1);
	}, []);

	const months = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	];
	const [loadIndex, setLoadIndex] = useState('requiredError');
	const [elemIndex, setElemIndex] = useState(null);
	const [toggle, setToggle] = useState(false);
	const [isChecked, setIsChecked] = useState(null);
	const [inputChange, setInputChange] = useState(false);



	const dispatch = useDispatch();
	const toggleFunction = (index) => {
		setShowCalculator(false)
		setIsCalculatorMounted(false)
		if (loadIndex === index) {
			setLoadIndex(null);
		} else if (elemIndex === index) {
			setToggle(!toggle);
		} else {
			setToggle(true);
		}
		setElemIndex(index);
		setLoadIndex(null);
	};


	const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
		<input
			value={value}
			className="example-custom-input"
			onClick={onClick}
			onChange={onChange}
			ref={ref}
		// type="date"
		></input>
	));



	let handleDocumentError = (data) => {
		dispatch(validationDataAction(true))
		valiadationData.processedDocument.errors.map((error, index) => {
			if (error?.code == data?.code) {
				if (error?.accepted) {
					error.accepted = !error.accepted
				}
				else {
					error.accepted = true
				}
			}
		})
		setValiadationDetail({ ...valiadationData })
	};

	const handleInputKeyPress = (e) => {
		const value = e.target.value;
		const decimalPosition = value.indexOf('.');
		if (decimalPosition !== -1) {
			const inputLength = value.substring(0, decimalPosition).length;
			if (inputLength >= 15) {
				e.preventDefault();
			}
		} else {
			if (value.length >= 15) {
				e.preventDefault();
			}
		}
		const decimalPosition1 = value.indexOf(".");
		// Allow "-" character only at the beginning or after a decimal point
		if (e.key === "-" && (value.length !== 0 && value.indexOf("-") === -1) && (decimalPosition1 !== -1 && e.target.selectionStart > decimalPosition1 || decimalPosition1 === -1 && e.target.selectionStart === 0)) {
			return;
		}

		if (e.key === "-" && (value.indexOf("-") !== -1 || e.target.selectionStart !== 0)) {
			e.preventDefault();
		}
	};

	const handleOnInput = (e) => {
		const value = e.targetoriginal_blob_name.value;
		// const decimalPosition = value.indexOf('.');
		// if (decimalPosition !== -1) {
		// 	const inputLength = value.substring(0, decimalPosition).length;
		// 	if (inputLength >= 15) {
		// 		e.preventDefault();
		// 	}
		// } else {
		// 	if (value.length >= 15) {
		// 		e.preventDefault();
		// 	}
		// }

	};

	const [isCalculatorMounted, setIsCalculatorMounted] = useState(false);

	useEffect(() => {
		if (showCalculator) {
			setIsCalculatorMounted(true);
		} else {
			setIsCalculatorMounted(false);
		}
	}, [showCalculator]);

	const toggleCalculator = (type, id, data) => {
        // setOutputValue(null)
        setDataForCalc(null)
        if (type.toLowerCase() === 'currency' || type.toLowerCase() === "decimal" || type.toLowerCase() === 'number') {
            setValidationKeyId(id)
			setDataForCalc(data?.value)
            // setShowCalculator(true);
        } else {
            // setShowCalculator(false);
            setOutputValue(null)
        }
    };

	useEffect(() => {
		if (outputValue != null) {
			_changesValidationText(outputValue, validationKeyId, '', 'number');
			setOutputValue(null);
		}
	}, [outputValue]);

	const checkTags = (tags) => {
		xmlTags(tags)
	}


	// const handleKeyPress = (e) => {
	// 	const regex = /^(-?(?:[0-9]+)?(?:\.[0-9]*)?)$/
	// 	const currentValue = e.target.value;
	// 	const key = e.key;

	// 	// // Allow the minus sign if it's the first character
	// 	// if (key === "-" && currentValue.length === 0) {
	// 	// 	return;
	// 	// }

	// 	// Prevent input if the value does not match the regex
	// 	const newValue = parseFloat(currentValue).toFixed(2);
	// 	if (!regex.test(currentValue + key)) {
	// 		e.preventDefault();
	// 		return;
	// 	}
	// 	else {
	// 	}
	// };

	// const handleKeyPress = (e) => {
	// 	const regex = /^(-?(?:[0-9]+)?(?:\.[0-9]*)?)$/;
	// 	const inputValue = e.target.value;

	// 	if (e.key === "." && !inputValue.includes(".")) {
	// 	  // Allow adding a decimal point if one doesn't already exist
	// 	  return;
	// 	}

	// 	const newValue =
	// 	  inputValue.slice(0, e.target.selectionStart) +
	// 	  e.key +
	// 	  inputValue.slice(e.target.selectionEnd);


	// 	if (!regex.test(newValue)) {
	// 	  e.preventDefault();
	// 	}
	// } ;

	// /^(-?(?:[0-9]+)?(\.[0-9]{0,2})?)$/
	// /^(-?(?:[0-9]+)?(\.[0-9]{0,2})?)$/

	// const handleKeyPress = (e) => {
	// };



	// const handleKeyDown = (e) => {
	// 	const regex = /^(-?(?:[0-9]+)?(?:\.[0-9]*)?)$/;
	// 	const currentValue = e.target.value;
	// 	const key = e.key;

	// 	// Check if text is selected and replace the selected portion with the typed key
	// 	if (e.target.selectionStart !== e.target.selectionEnd) {
	// 		const selectionStart = e.target.selectionStart;
	// 		const selectionEnd = e.target.selectionEnd;
	// 		const newValue =
	// 			currentValue.slice(0, selectionStart) +
	// 			key +
	// 			currentValue.slice(selectionEnd);

	// 		// Check if the new value matches the regex
	// 		if (!regex.test(newValue)) {
	// 			e.preventDefault();
	// 			return;
	// 		} else {
	// 		}
	// 	}
	// };

	// const handleKeyUp = (e) => {
	// 	const regex = /^(-?(?:[0-9]+)?(?:\.[0-9]*)?)$/;
	// 	const currentValue = e.target.value;
	// 	const key = e.key;

	// 	// Prevent input if the value does not match the regex
	// 	if (!regex.test(currentValue + key)) {
	// 		e.preventDefault();
	// 		return;
	// 	} else {
	// 	}
	// };

	// const handleKeyPress = (e) => {
	// 	const regex = /^(-?(?:[0-9]+)?(?:\.[0-9]*)?)$/;
	// 	const currentValue = e.target.value;
	// 	const key = e.key;

	// 	// Prevent input if the value does not match the regex

	// 	// if (!regex.test(currentValue + key)) {
	// 	// 	e.preventDefault();
	// 	// 	return;
	// 	// } else {
	// 	// }
	// };


	///^-?\d*\.?\d+$/

	const handleKeyPress = (e) => {

		// const regex = /^(-?(?:[0-9]+)?(?:\.[0-9]*)?)$/;
		// const currentValue = e.target.value;
		// const key = e.key;

		// // Prevent input if the value does not match the regex

		// if (!regex.test(currentValue + key)) {
		// 	e.preventDefault();
		// 	return;
		// } else {
		// }
		const regex = /^[^+]*$/;
		const currentValue = e.target.value;
		const key = e.key;
		// Allow negative sign only at the beginning or after 'e' in scientific notation
		// if (key === '-' && (currentValue !== '' && !currentValue.endsWith('e'))) {
		//   e.preventDefault();
		//   return;
		// }
		// Prevent input if the value does not match the regex
		if (!regex.test(currentValue + key)) {
			e.preventDefault();
			return;
		} else {
		}
		//toast  invalid currency ammount for fields, field2 
	};


	// new code start
	const isLeapYear = useCallback((year) => {
		return !((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
	}, []);

	// Updated isValidDate function
	const isValidDate = useCallback((day, month, year) => {
		if (month < 1 || month > 12) return "";
		const daysInMonth = [
			31, // January
			isLeapYear(year) ? 29 : 28, // February
			31, // March
			30, // April
			31, // May
			30, // June
			31, // July
			31, // August
			30, // September
			31, // October
			30, // November
			31, // December
		];

		if (day < 1 || day > daysInMonth[month - 1]) return false;
		if (year < 0) return false;
		return true;
	}, [isLeapYear]);

	const format = useCallback(
		(val) => {
			const digitsOnly = val.replace(/\D/g, "");
			const month = digitsOnly.slice(0, 2);
			const day = digitsOnly.slice(2, 4);
			const year = digitsOnly.slice(4, 8);

			if (digitsOnly.length <= 2) {
				return month;
			} else if (digitsOnly.length <= 4) {
				return `${month}/${day}`;
			}
			else {
				// Ensure the date is valid before displaying it
				if (isValidDate(parseInt(day), parseInt(month), parseInt(year))) {
					// Prevent input if the year starts with "0"
					if (year.startsWith("0000")) {
						return `${month}/${day}/`;
					}
					return `${month}/${day}/${year}`;
				} else {
					// If the date is invalid, return an empty string or any other message
					return "Invalid date format";
				}
			}
		},
		[isValidDate]
	);

	const onChangeRaw = useCallback(
		(e) => {
			e.target.value = format(e.target.value || "");
		},
		[format]
	);

	// const [date, setDate] = useState(new Date());
	const autoCorrectedDatePipe = createAutoCorrectedDatePipe('mm/dd/yyyy')
	// new code end 

	const handleBlur = (e, label) => {

		// if (!tag.value) {
		// 	return;
		// }
		// else {
		// 	if (!e.target.validity.valid) { // if invalid
		// 		if (!invalidFields.includes(label)) { // if not already present
		// 			setInvalidFields(prevInvalidFields => [...prevInvalidFields, label]);
		// 		}
		// 	} else { // if valid or now valid
		// 		setInvalidFields(prevInvalidFields => prevInvalidFields.filter(item => item !== label));
		// 	}
		// }
	}
	// Function is decleared for scroll wheel prevent functionality
	const numberInputOnWheelPreventChange = (e) => {
		// Prevent the input value change
		e.target.blur()
		// Prevent the page/container scrolling
		e.stopPropagation()
	}



	return (
		<>
			<div className="document-accordion-wrapper">
				{valiadationData?.processedDocument?.errors && valiadationData?.processedDocument?.errors.map((data, id) => {

					return (<div className={`accordion-blc d-flex flex-column required ${data?.accepted == true ? 'success' : ""} `}>

						<Button color="link" className={`accordion-btn text-start shadow-none text-left d-flex align-items-center ${(loadIndex === data?.code) || (data?.code === elemIndex && toggle) ? 'active' : ''}`} onClick={() => toggleFunction(data?.code)}>
							<span className="icon flex-shrink-0 align-self-start">
								<img className="img-fluid" src={require('../../../../assets/img/alert-icon.svg')} alt="Alert Icon" />
							</span>
							<div className="txt">
								<h2>{errorCode[data?.code]}</h2>
								<h2>{data?.title}</h2>
							</div>
							<span className="icon-btn ms-auto d-inline-flex flex-shrink-0">
								<img className="img-fluid" src={require('../../../../assets/img/arrow-dropdown-icon.svg')} alt="Arrow Icon" />
							</span>
						</Button>
						<Collapse isOpen={(loadIndex === data?.code) || (data?.code === elemIndex && toggle)}>
							<div className="collapse-data-blc">
								{/* <Input type="checkbox" checked={data?.accepted && data?.accepted} className="position-absolute" onClick={() => handleDocumentError(data)} />
								<ul className="required-items m-0">


									{data?.message} */}
								<ul className="loan-item-list list-unstyled">
									<li>
										<label className="checkbox-blc position-relative d-inline-flex">
											<Input type="checkbox" disabled={disabledInputText || unableToValidate} checked={data?.accepted && data?.accepted} className="position-absolute" onClick={(e) => { handleDocumentError(data); console.log('input running check 8', data.title); _OnVTextChange(e.target.value, data?.key ? data.key : '', data?.accepted, id, data?.code, undefined, undefined, data?.title ? data.title : '') }} />
											<span className="icon-box d-inline-flex align-items-center justify-content-center">
												<span className="icon d-inline-flex">
													<FontAwesomeIcon icon={faCheck} />
												</span>
											</span>
											<span className="txt">
												{data?.message}
											</span>
										</label>
									</li>
								</ul>
							</div>
						</Collapse>
					</div>)

				})}

				{valiadationData?.processedDocument?.results.map((data, id) => {
					let notes = [];
					let tags = [];
					let errors = [];
					let isAllFieldErrorAccepted = true
					let triggers = false;
					if (data?.triggers) {
						triggers = true;
					}
					data?.processingResult?.notes?.length && data.processingResult.notes.map((item) => {
						notes.push(item);
					})
					data?.processingResult?.tags?.length && data.processingResult.tags.map((item) => {
						tags.push(item?.tag)
						/*item?.errors && item.errors.map((data)=>{
							tags.push(data?.message)
						})*/
					})
					data?.processingResult?.errors?.length && data.processingResult.errors.map((item) => {
						errors.push({ ...item, key: data.key })
						if (item?.accepted != true) {
							isAllFieldErrorAccepted = false
						}
					})




					if (data?.processingResult?.potentialValues?.length) {

						if (data?.morioption == false) {
							data.index = null
						} else {
							let flag = data.processingResult.potentialValues.find((item, y) => {


								if (item == data?.value && inputChange == false) {
									data.index = y
									if (data?.morioption == undefined) {
										data.morioption = true
										data.previousMoriOptionValue = data.value
									}
									return true
								}
								return false
							})

							if (!flag && data?.morioption == undefined) {

								data.previousCustomValue = data.value
								//	data.processingResult.potentialValues.push(data?.value)
								//data.index = data.processingResult.potentialValues.length - 1

							}

						}

					}
					const handleFieldError = (item) => {
						dispatch(validationDataAction(true))
						valiadationData.processedDocument.results.map((data, index) => {
							data?.processingResult?.errors && data.processingResult.errors.map((errorItem, inx) => {
								if (item.code == errorItem.code && data.key == item.key) {
									if (errorItem.accepted) {
										errorItem.accepted = !errorItem.accepted

									}
									else {
										errorItem.accepted = true
									}


								}
							})
						})
						setValiadationDetail({ ...valiadationData })

					}

					return (
						// <div className={`accordion-blc d-flex flex-column success ${(errors.length > 0 && isAllFieldErrorAccepted != true) || (isValEmpty(data?.value) && (data?.required && isAllFieldErrorAccepted != true)) ? 'danger' : 'success'}`}>
						/***@start, conditions for red dashed boundry on field level*
						------------ (errors.length > 0 && isAllFieldErrorAccepted != true) || (isValEmpty(data?.value) && (data?.required) && errors.length == 0)
						if we find errors in field level and those field level errors are not accepted---->> Red Dashed Boundry OR
						if we are getting required field and the value of that required field is empty as well as there is no field errors----->> Red Dashed Boundry
						 * 
						*/
						<div className={`accordion-blc d-flex flex-column success ${(errors.length > 0 && isAllFieldErrorAccepted != true) || (isValEmpty(data?.value) && (data?.required) && errors.length == 0) ? 'danger' : 'success'}`}>
							<Button color="link" className={`accordion-btn text-start shadow-none text-left d-flex align-items-center ${(loadIndex === id) || (id === elemIndex && toggle) ? 'active' : ''}`} onClick={() => { toggleFunction(id); checkTags(data?.processingResult?.tags); toggleCalculator(data?.type, id, data); }}  onKeyDown={(e) => {
								if (e.key === 'Enter') {
									e.preventDefault();
								}
							}}>
								<div className="txt">
									<h2>{data?.label ? data?.label : data?.key} : <span>{data?.type == 'DateTime' ? (data?.value ? moment(data?.value).format(
										"MMM DD,YYYY"
									) : data?.value) : data?.type == "Boolean" ? data?.value != undefined ? data?.value == true ?  "True" : "False" : "" : (data?.type == 'Currency' ? (data?.value?.toString().split('.')[1] || [])?.length <= 2 ? data?.value?.toString().length ? (Number(data?.value)?.toFixed(2)).toString() == 'NaN' ? '' : Number(data?.value)?.toFixed(2) : data?.value : data?.value : data?.value)}</span></h2>




								</div>
								<span className="icon-btn ms-auto d-inline-flex flex-shrink-0">
									<img className="img-fluid" src={require('../../../../assets/img/arrow-dropdown-icon.svg')} alt="Arrow Icon" />
								</span>
							</Button>
							<Collapse isOpen={(loadIndex === id) || (id === elemIndex && toggle)}>
								<div className="collapse-data-blc">
									{data?.processingResult?.potentialValues ? <div className="row-block">
										<div className="options-blc">
											<label className="option-btn d-inline-flex align-items-center position-relative">
												<span className="input">
													<Input type="radio" disabled={disabledInputText || unableToValidate} checked={data?.morioption} onClick={() => { _selectMoriOption(true, id, data?.previousMoriOptionValue ? data?.previousMoriOptionValue : data?.value, data?.key); console.log('input running check 9') }} name={'option' + id} />
												</span>
												<span className="icon">
												</span>
												MORi Options
											</label>
											<div className="list-item-blc">
												<div className="option-items">

													{data?.processingResult?.potentialValues.map((result, x) => {
														return (
															<div className="item d-flex align-items-center">
																<label>{result}</label>
																<Button color="link" disabled={!data?.morioption || disabledInputText || unableToValidate} onClick={() => { _changesValidationText(result, id, data?.key, '', x, triggers); _OnVTextChange(result, data?.key ? data.key : ''); if (triggers) { setInputChange(false) }; }} className="ms-auto active">{data?.index == x ? 'Using' : 'Use'}</Button>
															</div>
														)
													})}

												</div>
											</div>
										</div>
									</div> : ''}
									{<div className="row-block">
										<div className="option-input-blc">
											<label className="option-btn d-flex align-items-center">
												{data?.processingResult?.potentialValues ? <span className="input">
													<Input type="radio" disabled={disabledInputText || unableToValidate} checked={!data?.morioption} value={data?.morioption} /*onBlur={() => { if(triggers) _validate() }} */ onClick={(e) => { if (e?.target?.value) _selectMoriOption(false, id, data?.previousCustomValue, data?.key); console.log('input running check 1') }} name={'option' + id} />
												</span> : ''}
												<span className="input-cell flex-fill">

													{data?.type == 'String' ?

														<Input disabled={data?.morioption || disabledInputText || unableToValidate} type="text" onBlur={() => { if (triggers) _validate() }} onChange={(e) => { _changesValidationText(e.target.value, id, data?.key); _OnVTextChange(e.target.value, data?.key ? data.key : ''); setInputChange(true); console.log('input running check 2') }} value={!isValEmpty(data?.index) ? '' : data?.value == undefined ? "" : data?.value} required={data?.required} className={`w-100 h-100 ${isValEmpty(data?.value) && data?.required ? "error" : ""}`} /> :
														data?.type == 'Currency' ? (
															// console.log(typeof data?.value, data?.value,"data?.value"),
															<div className="input-button-wrapper d-flex align-items-center">
																<Input
																	type="number"
																	step="any"
																	required={data?.required}
																	disabled={data?.morioption || disabledInputText}
																	value={!isValEmpty(data?.index) ? '' : data?.value == null ? "" : data?.value}
																	onBlur={(e) => { if (triggers) _validate(); handleBlur(e, data?.label) }}
																	// onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
																	onWheel={numberInputOnWheelPreventChange}
																	onChange={(e) => { console.log('input running check 3', typeof e.target.value, e.target.value); _changesValidationText(e.target.value ? Number(e.target.value) : '', id, '', 'number'); _OnVTextChange(e.target.value, data?.key ? data.key : ''); 
																		setDataForCalc(e.target.value)
																	}}
																	className={`w-100 h-100 ${isValEmpty(data?.value) && data?.required ? "error" : ""}`}
																	onKeyPress={(e) => handleKeyPress(e)}

																/>
																<Button onClick={() => setShowCalculator(prev => !prev)} className="toggle-calculator-btn">
																	<FontAwesomeIcon icon={faCalculator} style={{fontSize: '16px'}} />
																</Button>
															</div>
														) // onInput={(e) => { handleOnInput(e) }}
															: data?.type == 'Decimal' || data?.type == "Number" ? 
															(
																<div className="input-button-wrapper d-flex align-items-center">
																<Input type="number" 
																required={data?.required} 
																disabled={data?.morioption || disabledInputText || unableToValidate} 
																value={!isValEmpty(data?.index) ? '' : data?.value == null ? "" : data?.value} 
																onBlur={() => { if (triggers) _validate() }} 
																onChange={(e) => { console.log('input running check 4'); _changesValidationText(e.target.value ? Number(e.target.value) : '', id, '', 'number');
																_OnVTextChange(e.target.value, data?.key ? data.key : '');
																setDataForCalc(e.target.value)
															    }} 
																className={`w-100 h-100 ${isValEmpty(data?.value) && data?.required ? "error" : ""}`} 
																onWheel={numberInputOnWheelPreventChange} />
																<Button onClick={() => setShowCalculator(prev => !prev)} className="toggle-calculator-btn">
																	<FontAwesomeIcon icon={faCalculator} style={{fontSize: '16px'}} />
																</Button>
																</div>
															) :
																data?.type == "Boolean" ? (

																	(
																		<div >
																			<div>
																				<label className="option-btn d-flex align-items-center" >
																					<Input
																						type="radio"
																						value="true"
																						checked={data?.value === true}
																						onChange={(e) => {
																							console.log('True clicked');
																							_changesValidationText(true, id, '', '');
																							_OnVTextChange(true, data?.key ? data.key : '');
																						}}
																					/>
																					<span style={{ marginLeft: '5px' }}>True</span>
																				</label>
																			</div>
																			<div>
																				<label className="option-btn d-flex align-items-center">
																					<Input
																						type="radio"
																						value="false"
																						checked={data?.value === false}
																						onChange={(e) => {
																							console.log('False clicked');
																							_changesValidationText(false, id, '', '');
																							_OnVTextChange(false, data?.key ? data.key : '');
																						}}
																					/>
																					<span style={{ marginLeft: '5px' }}>False</span>
																				</label>
																			</div>
																		</div>
																	)




																) : data?.value ?

																	/* <Input
																		 type="date"
																		 value={data?.value.split('T')[0]}
																		 dateFormat="mm-dd-yyyy"
																		 max='9999-12-31'
																		 defaultValue={data?.value.split('T')[0]}
																		 onChange={(e) => {
																		 	
																		 	
																			 _changesValidationText(e.target.value ? e : '', id, '', data?.type);
		 
																		 }
																		 }
																	 	
																		 className={`${(data?.required && !data?.value) || !moment(data?.value).isValid()  ? "error" : ""}`}
																	 /> : <Input
																		 type="date"
																		 dateFormat="mm-dd-yyyy"
																		 max='9999-12-31'
																		 className={`${data?.required && !data?.value ? "error" : ""}`}
																		 onChange={(e) => {
																		 	
																			 _changesValidationText(e.target.value ? e : '', id, '', data?.type);
		 
																		 }
																		 }
																	 	
																	 />*/
																	<DatePicker
																		renderCustomHeader={({
																			date,
																			changeYear,
																			changeMonth,
																			decreaseMonth,
																			increaseMonth,
																			prevMonthButtonDisabled,
																			nextMonthButtonDisabled,
																		}) => (
																			<div
																				style={{
																					margin: 10,
																					display: "flex",
																					justifyContent: "center",
																				}}
																			>
																				<button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
																					{"<"}
																				</button>
																				<select
																					value={date.getFullYear()}
																					onChange={({ target: { value } }) => changeYear(Number(value))}
																				>
																					{years.map((option) => (
																						<option key={option} value={option}>
																							{option}
																						</option>
																					))}
																				</select>

																				<select
																					value={months[date.getMonth()]}
																					onChange={({ target: { value } }) =>
																						changeMonth(months.indexOf(value))
																					}
																				>
																					{months.map((option) => (
																						<option key={option} value={option}>
																							{option}
																						</option>
																					))}
																				</select>

																				<button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
																					{">"}
																				</button>
																			</div>
																		)}
																		// format="MM/DD/YY"
																		// showYearDropdown 
																		// yearDropdownItemNumber={999}
																		// onChangeRaw={onChangeRaw}
																		// scrollableYearDropdown
																		// showMonthDropdown
																		required={data?.required}
																		//placeholderText="I have been cleared!"
																		disabled={data?.morioption || disabledInputText}
																		selected={data?.value ? new Date(data?.value) : ""}

																		//customInput={<ExampleCustomInput />}
																		onBlur={() => { if (triggers) _validate() }}

																		onChange={(date, e) => {
																			// alert("11111111")
																			e.preventDefault()
																			_changesValidationText(date, id, '', data?.type);
																			_OnVTextChange(date, data?.key ? data.key : '', undefined, undefined, undefined, data?.type ? data.type : '');
																			console.log('input running check 5', data.value, data.key, data.type)
																		}
																		}
																		className={`date-range form-control ${data?.required && !data?.value ? "error" : ""}`}
																		customInput={
																			<MaskedInput
																				pipe={autoCorrectedDatePipe}
																				mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
																				keepCharPositions={true}
																				guide={true}
																			/>
																		}
																	// customInput={<DateInput />}
																	// onKeyDown={(e) => {
																	// 	e.preventDefault();
																	// }}
																	/> :
																	<DatePicker
																		renderCustomHeader={({
																			date,
																			changeYear,
																			changeMonth,
																			decreaseMonth,
																			increaseMonth,
																			prevMonthButtonDisabled,
																			nextMonthButtonDisabled,
																		}) => (
																			<div
																				style={{
																					margin: 10,
																					display: "flex",
																					justifyContent: "center",

																				}}
																			>
																				<button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
																					{"<"}
																				</button>
																				<select
																					value={date.getFullYear()}
																					onChange={({ target: { value } }) => changeYear(Number(value))}
																				>
																					{years.map((option) => (
																						<option key={option} value={option}>
																							{option}
																						</option>
																					))}
																				</select>

																				<select
																					value={months[date.getMonth()]}
																					onChange={({ target: { value } }) =>
																						changeMonth(months.indexOf(value))
																					}
																				>
																					{months.map((option) => (
																						<option key={option} value={option}>
																							{option}
																						</option>
																					))}
																				</select>

																				<button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
																					{">"}
																				</button>
																			</div>
																		)}
																		format="MM/DD/YY"
																		// showYearDropdown 
																		// yearDropdownItemNumber={999}
																		// onChangeRaw={onChangeRaw}
																		// scrollableYearDropdown
																		// showMonthDropdown
																		placeholderText="mm/dd/yyyy"
																		required={data?.required}
																		disabled={data?.morioption || disabledInputText || unableToValidate}
																		//customInput={<ExampleCustomInput />}
																		onBlur={() => { if (triggers) _validate() }}
																		onChange={(date, e) => {
																			e.preventDefault()
																			_changesValidationText(date, id, '', data?.type);
																			_OnVTextChange(date, data?.key ? data.key : '', undefined, undefined, undefined, data?.type ? data.type : '');
																			console.log('input running check 6')
																		}
																		}
																		className={`date-range form-control ${data?.required && !data?.value ? "error" : ""}react-datepicker .react-datepicker__month-dropdown,.react-datepicker__year-dropdown`}
																		customInput={
																			<MaskedInput
																				pipe={autoCorrectedDatePipe}
																				mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
																				keepCharPositions={true}
																				guide={true}
																			/>
																		}
																	//customInput={<DateInput />}
																	// onKeyDown={(e) => {
																	// 	e.preventDefault();
																	// }}
																	/>


														/*<DatePicker
															required={data?.required}
															disabled={data?.morioption || disabledInputText}
															selected={new Date(data?.value)}
															onChange={(date: Date) => { 
															 _changesValidationText(date, id, '', data?.type);
															 
															 }
															}
															className={`date-range form-control ${data?.required && !data?.value ? "error" : ""}`}
															onKeyDown={(e) => {
																e.preventDefault();
															}} 
															
														/> : <DatePicker
															required={data?.required}
															disabled={data?.morioption || disabledInputText}
															onChange={(date: Date) => {
																_changesValidationText(date, id, '', data?.type)
																
															}}
															className={`date-range form-control ${data?.required && !data?.value ? "error" : ""}`}
															onKeyDown={(e) => {
																e.preventDefault();
															}}
														/>*/

													}
													{data?.type === "DateTime" ? "e.g: 01/31/1980 (mm/dd/yyyy)" : ""}
													{showCalculator && isCalculatorMounted && <Calculator inputValue={dataForCalc != null ? dataForCalc : ""} onOutputChange={(output) => setOutputValue(output)} />}
												</span>
											</label>
											{data?.isOverride != undefined && <div style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
												<span className="input">
													<Input
														type="checkbox"
														disabled={disabledInputText || unableToValidate}
														checked={data?.isOverride}
														onClick={(e) => {
															console.log('input running check 10', data.title);
															_changesValidationText(e.target.checked, id, data.key, 'is_over_ride')

														}}
													/>
												</span>
												<span className="txt" style={{ marginLeft: "5px" }}>
													Override MORi Derived Value
												</span>
											</div>}

										</div>
									</div>}
									<div className="row-block">
										<div className="descrition-items">
											{errors.length != 0 ? <div className="item d-flex flex-wrap error-blc-wrapper">
												<label className="txt flex-fill">Errors : </label>
												{errors?.map((item, index) => (
													<div>
														<div className="error-blc active">
															<label className="checkbox-blc position-relative d-inline-flex align-items-center">
																<Input type="checkbox" disabled={disabledInputText || unableToValidate} checked={item?.accepted && item?.accepted} className="position-absolute" onClick={(e) => { handleFieldError(item); _OnVTextChange(e.target.value, data?.key ? data.key : '', !item?.accepted, id, undefined, undefined, index); console.log('input running check 7') }} />
																<span className="icon-box d-inline-flex align-items-center justify-content-center">
																	<span className="icon d-inline-flex">
																		<FontAwesomeIcon icon={faCheck} />
																	</span>
																</span>
																<span className="txt">{item?.title}</span>
															</label>
															<div className="error-desc">
																<p>
																	{/* Address from the ID could not be validated and was not compared to the LOS address.,
																Address from LOS could not be validated. Please confirm accuracy. */}
																	{item?.message}
																</p>
															</div>
														</div>
														{/* <div className="error-blc">
													<label className="checkbox-blc position-relative d-inline-flex align-items-center">
														<Input type="checkbox" className="position-absolute" />
														<span className="icon-box d-inline-flex align-items-center justify-content-center">
															<span className="icon d-inline-flex">
																<FontAwesomeIcon icon={faCheck} />
															</span>
														</span>
														<span className="txt">Organizational Roles</span>
													</label>
													<div className="error-desc">
														<p>
															Address from the ID could not be validated and was not compared to the LOS address.,
															Address from LOS could not be validated. Please confirm accuracy.
														</p>
													</div>
												</div> */}
														{/* {arrayToString(errors)} */}
													</div>
												))}
											</div> : ''}
											{notes.length != 0 ? <div className="item d-flex flex-column">
												<label className="txt d-inline-flex">Notes : </label>
												<div className="dotdesc">
													<ul>
														{notes.map((item, index) => (
															<li>{item}</li>
														))}
													</ul>
													{/*arrayToString(notes)*/}
												</div>
											</div> : ''}
											{tags.length != 0 ? <div className="item d-flex">
												<label className="txt d-inline-flex">Tag(s) : </label>
												<div className="desc">
													{arrayToString(tags)}
												</div>
											</div> : ''}

										</div>
									</div>
								</div>
							</Collapse>
						</div>)


				})}


				{!valiadationData && (<NoRecord2 />)}


			</div>
		</>
	)
};


export default DocumentAccordion;